module.exports = __webpack_public_path__ + "504599e18bcd96a79b0fbdacbc74abd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2000_70_teaser_image.jpg
// module id = 550
// module chunks = 0